import i18n from '@/i18n';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { createToastContent } from '@/utilities/toast';
import { computed, reactive, ref } from 'vue';
import { useToast } from 'vue-toastification';
import { ErrorCodes } from '../../shared/types';
import { createAnalyticsUser, validateAnalyticsUser } from '../data';
const toast = useToast();
const { t } = i18n.global;
const toastOptions = {
    icon: false,
    toastClassName: 'login-toaster',
    timeout: 6000,
};
export function useAnalyticsAuth() {
    const loading = ref(false);
    const userData = reactive({ id: null, name: '', imported: false, createdAt: null, accessToken: null });
    const isValidUser = computed(() => !!userData.accessToken);
    async function validateUser(login, password) {
        loading.value = true;
        const result = await validateAnalyticsUser(login, password);
        if (!result.success) {
            const content = createToastContent(t('login360.toast.notFound.title'), t('login360.toast.notFound.message'));
            toast.error(content, toastOptions);
            loading.value = false;
            return;
        }
        userData.id = result.data.id;
        userData.accessToken = result.data.accessToken;
        loading.value = false;
        useMixpanelConfig('view_migration360_analytics_registry');
    }
    async function createUser(email) {
        loading.value = true;
        const { id, accessToken } = userData;
        const result = await createAnalyticsUser({ id: String(id), email, token: accessToken });
        if (!result.success) {
            const error = result.error;
            let content;
            if (error === ErrorCodes.USER_LOGIN_ALREADY_EXISTS) {
                content = createToastContent(t('login360.toast.alreadyRegistered.title'), t('login360.toast.alreadyRegistered.message'));
                useMixpanelConfig('view_migration360_analytics_error_registered');
            }
            else {
                content = createToastContent(t('login360.toast.notFound.title'), t('login360.toast.notFound.message'));
            }
            useMixpanelConfig('view_migration360_analytics_error_notidentified');
            toast.error(content, toastOptions);
            loading.value = false;
            return false;
        }
        userData.id = result.data.userId;
        const content = createToastContent(t('login360.toast.creationSuccess.title'), t('login360.toast.creationSuccess.message'));
        useMixpanelConfig('view_migration360_analytics_success');
        toast.success(content, { ...toastOptions, icon: true });
        loading.value = false;
        return true;
    }
    return {
        loading,
        isValidUser,
        validateUser,
        createUser,
    };
}
